import type { Middleware } from 'openapi-fetch'

export interface TokenInfo {
  accessToken: string
  tokenType: string
}

/**
 * Creates a middleware that attaches an Authorization header to every request.
 *
 * The `getToken` callback is invoked on each request so token values are always
 * read fresh from whatever store the app uses (in-memory, Zustand, etc.).
 *
 * Return `null` from `getToken` to skip the header (e.g. unauthenticated requests).
 */
export function createAuthMiddleware(getToken: (request: Request) => TokenInfo | null): Middleware {
  return {
    onRequest: ({ request }) => {
      const token = getToken(request)

      if (token) {
        request.headers.set('Authorization', `${token.tokenType} ${token.accessToken}`)
      }

      return request
    },
  }
}
